/**
 * @file Fires a 'Page Viewed' Mixpanel event on every route change.
 *
 * Reports the matched route PATTERN (e.g. '/properties/:structureId'), never the
 * concrete URL, so entity ids stay out of the analytics service. Must be mounted
 * inside the BrowserRouter.
 */
import * as React from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import useMixPanel from '@/hooks/useMixPanel';

import { routes } from '../app-routes';

/** Route patterns checked in order; more specific patterns come first. */
const PAGE_PATTERNS: string[] = [
  routes.unit,
  routes.property,
  '/report/:reportID',
  '/account/settings/return',
  '/account/settings/refresh',
  '/account/settings',
  '/accounts/reset-password',
  '/release-notes',
  routes.home,
];

export const getPagePattern = (pathname: string): string =>
  PAGE_PATTERNS.find((pattern) => matchPath(pattern, pathname) !== null) ?? 'other';

export const RouteTracker = (): null => {
  const location = useLocation();
  const { trackEvent } = useMixPanel();

  React.useEffect(() => {
    trackEvent('Page Viewed', { path: getPagePattern(location.pathname) });
    // trackEvent is recreated every render; only the pathname should retrigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null;
};
